import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Button,
  Card,
  CardTitle,
  CardText,
  Modal,
  Input,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { useDispatch } from "react-redux";
import {
  setDivScrollYPosition,
  setWindowScrollYPosition,
} from "../../../store/job/action";
import { Link } from "react-router-dom";
import { DateHelper } from "@workspace/common";
import "./JobDetails.scss";
import { toast } from "react-toastify";
import { TooltipWrapper } from "@workspace/common";

export default function JobDetailsCard({ selectedJob }) {
  const { id, submissionData } = selectedJob;
  const dispatch = useDispatch();
  const [shareModal, setShareModal] = useState(false);
  const [buttonText, setButtonText] = useState("Copy Link");
  const [job, setJob] = useState({});
  const toggleShareModal = () => setShareModal(!shareModal);

  useEffect(() => {
    if (submissionData) {
      try {
        // Parse submissionData to JSON object
        const job = JSON.parse(submissionData);
        setJob(job);
      } catch (e) {
        console.error(e);
      }
    }
  }, [submissionData]);

  // Save scroll position in localStorage when user clicks on Apply Now button
  function handleScrollPosition() {
    const divElement = document.querySelector("#scrollableDiv");
    if (divElement) {
      dispatch(setDivScrollYPosition(divElement.scrollTop));
      dispatch(setWindowScrollYPosition(window.scrollY));
    }
  }

  // Copy Link
  const copyLinkToClipboard = (link) => {
    navigator.clipboard
      .writeText(link)
      .then(() => {
        setButtonText("Link Copied");
        setTimeout(() => {
          setButtonText("Copy Link");
        }, 3000);
        toast.success("Job link copied to clipboard!");
      })
      .catch((err) => {
        toast.error("Failed to copy: ", err);
      });
  };

  return (
    <React.Fragment>
      <Card className="mt-1 p-4 jobdetails-card">
        <Row className="mx-0 mb-2">
          <Col className="d-flex align-items-baseline justify-content-between px-0">
            <CardText tag="h5" className="mb-0">
              {job?.jobTitle}
            </CardText>
            <div className="d-flex flex-row align-items-baseline gap-1">
              <Button onClick={toggleShareModal} className="share-button">
                <span className="me-1">Share</span>
                <span className="mdi mdi-share"></span>
              </Button>
              <div className="d-flex flex-row align-items-baseline">
                <i className="las la-map-marker me-1" />
                <TooltipWrapper
                  tooltipText={`${job?.country}, ${job?.workLocation}`}
                >
                  <CardText
                    className="color-slategray"
                    style={{
                      maxWidth: "270px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {job?.country}, {job?.workLocation}
                  </CardText>
                </TooltipWrapper>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="d-flex align-items-start mx-0 py-2 bg-light rounded">
          <Col className="flex-center-column" xs="4" xl="2">
            <div className="d-flex align-items-center">
              <i className="ri-briefcase-line" />
            </div>
            <small className="color-slategray">JOB ID</small>
            <h6 className="mt-1">{job?.jobId}</h6>
          </Col>
          <Col className="flex-center-column" xs="4" xl="2">
            <div className="d-flex align-items-center">
              <i className="mdi mdi-calendar-blank-outline" />
            </div>
            <small className="color-slategray">DATE POSTED</small>
            <h6 className="mt-1">
              {DateHelper.formatDateStandard2(job?.dateOpen)}
            </h6>
          </Col>
          <Col className="flex-center-column" xs="4" xl="2">
            <div className="d-flex align-items-center">
              <i className="mdi mdi-timer-outline" />
            </div>
            <small className="color-slategray">JOB EXPIRE IN</small>
            <h6 className="mt-1">
              {DateHelper.formatDateStandard2(job?.targetClosingDate)}
            </h6>
          </Col>
          <Col className="flex-center-column" xs="4" xl="2">
            <div className="d-flex align-items-center">
              <i className="mdi mdi-layers-triple-outline" />
            </div>
            <small className="color-slategray">WORK MODE</small>
            <h6 className="mt-1">{job?.workType}</h6>
          </Col>
          <Col className="flex-center-column" xs="4" xl="2">
            <div className="d-flex align-items-center">
              <i className="ri-wallet-line" />
            </div>
            <small className="color-slategray">SALARY</small>
            <h6 className="mt-1">{job?.payrate}</h6>
          </Col>
          <Col className="flex-center-column" xs="4" xl="2">
            <div className="d-flex align-items-center">
              <i className="ri-building-line" />
            </div>
            <small className="color-slategray">JOB-TYPE</small>
            <h6 className="mt-1">{job?.jobType}</h6>
          </Col>
        </Row>
        <Row className="mx-0">
          <Col className="px-0">
            <Button
              className="flex-center w-100 my-4 bg-trueblue"
              tag={Link}
              to={`/job-portal/${id}`}
              onClick={handleScrollPosition}
            >
              Apply Now
              <i
                className="mdi mdi-arrow-right ms-1"
                style={{ fontSize: "1.25rem" }}
              />
            </Button>
          </Col>
        </Row>
        <Row className="mx-0">
          <Col className="px-0">
            <CardTitle tag="h5" className="mb-4">
              Job Description
            </CardTitle>
          </Col>
        </Row>
        <Row className="mx-0">
          <Col className="px-0">
            <div
              className="fs-15 color-blackcoral"
              dangerouslySetInnerHTML={{ __html: job.Jobdescription }}
            />
          </Col>
        </Row>
      </Card>
      <Modal
        isOpen={shareModal}
        toggle={toggleShareModal}
        centered
        backdrop={false}
      >
        <div className="modal-header">
          <div className="d-flex flex-row justify-content-between align-items-start w-100">
            <div className="d-flex flex-column gap-1">
              <span className="fw-semibold">Share {job?.jobTitle} Job</span>
              <span className="text-muted text-dark">
                Expand your impact! Share this job with your network.
              </span>
            </div>
            <span
              onClick={toggleShareModal}
              className="cursor-pointer mdi mdi-close"
            ></span>
          </div>
        </div>
        <div className="modal-body">
          <div>
            <InputGroup>
              <InputGroupText className="copy-link-wrapper">
                <span className="mdi mdi-link-variant copy-link-text"></span>
              </InputGroupText>
              <Input
                disabled
                className="copy-link-input"
                value={`${window.location.origin}/job-portal/home?jobId=${job?.jobId}`}
              />
              <InputGroupText
                onClick={() =>
                  copyLinkToClipboard(
                    `${window.location.origin}/job-portal/home?jobId=${job?.jobId}`
                  )
                }
                className="share-button cursor-pointer"
              >
                {buttonText}
              </InputGroupText>
            </InputGroup>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
}
